import Header from "components/layouts/header/header.component";
import styled from "styled-components";

export default styled(Header)``;
